import { useLeafletContext } from '@react-leaflet/core'
import L from 'leaflet';
import { useEffect } from 'react';

export default function Direction(props) {
    const context = useLeafletContext()

    L.Control.Watermark = L.Control.extend({
        onAdd: function (map) {
            var icon = document.createElement("img");
            icon.src = '/icons/target.png';
            icon.style.width = '35px';

            var Direction = L.DomUtil.create('a');
            Direction.href = `https://www.google.com.au/maps/dir//${props.location.lat},${props.location.lng}/@${props.location.lat},${props.location.lng},11z?hl=en`;
            Direction.target = "_blank";
            Direction.appendChild(icon);
            Direction.style.cursor = "pointer"
            return Direction;
        },
    });

    L.control.watermark = function (opts) {
        return new L.Control.Watermark(opts);
    }

    useEffect(() => {
        const container = context.layerContainer || context.map

        const control = L.control.watermark({ position: props.position })
        container.addControl(control)

        return () => {
            container.removeControl(control)
        }
    })

    return null
}